export default {
	"RuleClick.ActivityRules": "Activity rules"
}